import React from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import BigTabListItem from '../../../components/BigTabItem/BigTabListItem';
import BigNavItem from '../../../components/BigTabItem/BigTabListItemNav';
import BigTabNav from '../../../components/BigTabItem/BigTabNav';
import PageTitle from '../../../components/typography/PageTitle';
import { L } from '../../../lib/i18n';
import CreateNewNewsPage from './CreateNewNewsPage/CreateNewNews';
import NewsDetailPage from './DetailPage/NewsDetailPage';
import { useGetMemberNewsById } from './hooks/memberNewsQueries';
import NewsDraftListpage from './ListPage/NewsDraftListPage';
import NewsPublishedListpage from './ListPage/NewsPublishedListPage';

const MemberNewsPage = () => {
    const { id } = useParams<{ id: string }>();
    const { data } = useGetMemberNewsById(+id);

    return (
        <>
            <PageTitle>{L('member_news_title')}</PageTitle>
            <BigTabNav>
                <BigNavItem exact to={'/news'}>
                    {L('all_published')}
                </BigNavItem>
                <BigNavItem exact to={'/news/draft'}>
                    {L('draft')}
                </BigNavItem>
                <Switch>
                    <Route exact path={'/news/draft'} />
                    <Route exact path={'/news/new'}>
                        <div style={{ borderRight: 'solid 1px gray' }} />
                        <BigTabListItem className="active">{L('new_news_page')}</BigTabListItem>
                    </Route>
                    <Route path={'/news/:id'}>
                        <div style={{ borderRight: 'solid 1px gray' }} />
                        <BigNavItem exact to={`/news/${data?.id}`}>
                            {data?.title}
                        </BigNavItem>
                    </Route>
                </Switch>
            </BigTabNav>
            <Switch>
                <Route path={'/news/new'}>
                    <CreateNewNewsPage />
                </Route>
                <Route exact path={'/news/draft'}>
                    <NewsDraftListpage />
                </Route>
                <Route path={'/news/:id'}>
                    <NewsDetailPage />
                </Route>
                <Route exact path={'/news'}>
                    <NewsPublishedListpage />
                </Route>
            </Switch>
        </>
    );
};

export default MemberNewsPage;
